/* eslint-disable @next/next/no-img-element */
import * as React from 'react';
import { useCallback, useLayoutEffect, useState } from 'react';
import { OverviewImageLinkPoint } from './OverviewImageModal.types';
import { useOverviewImage } from './utils/useOverviewImage';

const getPolygonPoints = (points: OverviewImageLinkPoint[]): string =>
  points.map(({ x, y }) => `${x},${y}`).join(' ');

export const OverviewImagesModal: React.FC = () => {
  const [containerRect, setContainerRect] = useState<DOMRect>();
  const { imageUrl, size, naturalSize, linkConfigs } = useOverviewImage({ containerRect });
  const { width, height } = size;
  const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(null);

  const handleContainerRef = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      setContainerRect(node.getBoundingClientRect());
      setContainerNode(node);
    }
  }, []);

  useLayoutEffect(() => {
    const updateContainerSize = (): void => {
      if (containerNode !== null) {
        setContainerRect(containerNode.getBoundingClientRect());
      }
    };

    window.addEventListener('resize', updateContainerSize);
    return () => window.removeEventListener('resize', updateContainerSize);
  }, [containerNode]);

  if (!imageUrl) {
    return null;
  }

  return (
    <div
      data-testid="overview-images-modal"
      className="flex h-full w-full items-center justify-center bg-white"
      ref={handleContainerRef}
    >
      <div className="relative" style={{ width, height }}>
        <img alt="overview" className="block h-full w-full" src={imageUrl} />
        <svg
          data-testid="overview-image-links"
          className="absolute left-0 top-0 h-full w-full"
          viewBox={`0 0 ${naturalSize.width} ${naturalSize.height}`}
          preserveAspectRatio="none"
        >
          {linkConfigs.map(({ points, onClick, idObject }) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <polygon
              role="button"
              tabIndex={0}
              key={idObject}
              className="cursor-pointer"
              fill="transparent"
              points={getPolygonPoints(points)}
              onClick={onClick}
            />
          ))}
        </svg>
      </div>
    </div>
  );
};
